import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { StickyFilters } from '@web/components/Filters/StickyFilters';
import { OverviewSection } from '@web/components/PerformanceReview/Employee/Sections/Overview';
import { Page } from '@web/pages/layout/Page';
import { useFilters } from '@web/utility/hooks/useFilters';
import { usePageTitle } from '@web/utility/hooks/usePageTitle';
export var DashboardView = function () {
    var _a = useFilters(), userId = _a.user, orgUnitId = _a.orgUnit, dateFrom = _a.dateFrom, dateTo = _a.dateTo;
    usePageTitle('Dashboard');
    return (_jsx(Page, { children: _jsxs(_Fragment, { children: [_jsx(StickyFilters, { orgUnits: { resetUserOnAll: true } }), _jsx(OverviewSection, { userId: userId, orgUnitId: orgUnitId, dateFrom: dateFrom, dateTo: dateTo })] }) }));
};
